import axios from "axios";
import { config } from "../../_config/config";
import tokenService from "../../_services/token.service";
import {
  AdminCompanyExtended,
  AdminOffer,
  CandidateRow,
  AdminCandidateDetail,
  AdminCandidateListRow,
} from "./admin-types";

const baseUrl = config.SERVER_URL;

const getBody = <T>(data: any): T => (data && data.body ? data.body : data);

async function getAuthed<T>(
  path: string,
  params?: Record<string, any>
): Promise<T> {
  const token = tokenService.getLocalAccessToken();
  const response = await axios.get(baseUrl + path, {
    headers: { Authorization: "Bearer " + token },
    params,
  });
  return response.data;
}

export const adminService = {
  async fetchCompanies(): Promise<AdminCompanyExtended[]> {
    const raw = await getAuthed<any>("company/", { size: 50 });
    const body = getBody<any>(raw);
    return body.data || [];
  },

  async fetchCompanyOffers(companyId: string): Promise<AdminOffer[]> {
    const raw = await getAuthed<any>(`offer/company/${companyId}/`, {
      size: 50,
    });
    const body = getBody<any>(raw);
    return body.data || [];
  },

  async fetchOfferCandidates(offerId: string): Promise<CandidateRow[]> {
    const raw = await getAuthed<any>(`offer/${offerId}/candidates`, {
      size: 50,
    });
    return raw.body || [];
  },

  async fetchCandidates(): Promise<AdminCandidateListRow[]> {
    const raw = await getAuthed<any>("candidate/", { size: 50 });
    const body = getBody<any>(raw);
    return body.data || [];
  },

  async fetchCandidate(
    candidateId: string
  ): Promise<AdminCandidateDetail | null> {
    const raw = await getAuthed<any>(`candidate/${candidateId}`);
    const body = getBody<any>(raw);
    return body || null;
  },
};
